import { styled } from "goober";
import { mobileMedia } from "../hooks/useIsMobile";
import { ClickButton } from "./ClickButton";
import { PressButton } from "./PressButton";

const footerActionStyle = `
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: inherit;

  @media (hover: hover) {
    &:hover:not(:disabled) {
      color: var(--text-primary);
      --keycap-fg: var(--text-primary);
      --keycap-bg: var(--alpha8);
    }
  }

  ${mobileMedia} {
    padding: 4px 6px;
    margin: -4px -2px;
    border-radius: 4px;

    &:hover {
      background: var(--alpha4);
    }

    &:active {
      background: var(--alpha8);
    }
  }
`;

export const FooterAction = styled(PressButton)`
  ${footerActionStyle}
`;

export const FooterClickAction = styled(ClickButton)`
  ${footerActionStyle}
`;
